module.exports = __webpack_public_path__ + "img/nutrition_1.7314e304.jpg";